var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 23"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".documents_svg__cls-1{fill:none;stroke:currentColor;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documents_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents_svg__Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents_svg__two-files"
  }, /*#__PURE__*/React.createElement("path", {
    className: "documents_svg__cls-1",
    d: "M15 22.5H1.5a1 1 0 01-1-1v-16a1 1 0 011-1H11l5 5.5v11.5a1 1 0 01-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "documents_svg__cls-1",
    d: "M11 5v5h5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "documents_svg__cls-1",
    d: "M5 4.5v-3a1 1 0 011-1h9.5l5 5.5v11.5a1 1 0 01-1 1h-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "documents_svg__cls-1",
    d: "M15.5 1v5h5M3.5 11H7M3.5 13.5h9M3.5 16h9M3.5 18.5h9"
  }))))));
}
export default SvgDocuments;